// @flow

export const contexts = {
  CHATBOT: 'chatbot',
  WIZARD: 'wizard'
}

export type Context = $Values<typeof contexts>
